import { useTimeOffsApi } from '@pages/tutor-kanban'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const tutorId = to.params.id as string

  void useTimeOffsApi({ tutorId })
})
